<script>
export default {
  name: 'EuAutocomplete',
  props: {
    value: {
      type: String,
      default: null
    },
    fetchOptions: Function,
    queryParams: {
      type: Object,
      required: false
    },
  },
  data() {
    return {
      
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  async mounted() {
    // await this.loadData();
  },
  methods: {
    async loadData(keyword) {
      try {
        const params = {
          ...this.queryParams,
          keyword
        }
        const res = await this.fetchOptions(params)
        return res.data || []
      } catch (err) {
        console.error('获取数据失败:', err)
      }
      return []
    },
    async querySearch(queryString, cb) {
      const options = await this.loadData(queryString)
      cb(options)
    },
  }
}
</script>
<template>
  <el-autocomplete
    v-model="localValue"
    :fetch-suggestions="querySearch"
    placeholder="请输入内容"
    :trigger-on-focus="false"
    v-bind="$attrs"
    style="width: 100%"
  ></el-autocomplete>
</template>

<style scoped lang="scss">

</style>


